import React from "react";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import isEmpty from "lodash/isEmpty";
import moment from "moment";

// const dateFormat = "MMM D, YYYY";

// momentjs format doc: https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
const validatedFormat = [
  moment.ISO_8601,
  "MMM D, YYYY", // [Jan Feb ... Nov Dec] [1 2 ... 30 31], [1970 1971 ... 2029 2030]
  "MMMM D, YYYY", // January February ... November December] [1 2 ... 30 31], [1970 1971 ... 2029 2030]
  "MMM DD, YYYY", // [Jan Feb ... Nov Dec] [01 02 ... 30 31], [1970 1971 ... 2029 2030]
  "MMMM DD, YYYY", // [January February ... November December] [01 02 ... 30 31], [1970 1971 ... 2029 2030]
];

export function isValidDateString(string) {
  return moment(string, validatedFormat, true).isValid();
}

export default function dateFormatConverter(matchedPhase, stringOnly) {
  // stringOnly is a boolean and if it's true, return only text
  // if not, return object with title or props
  const na = stringOnly
    ? "N/A"
    : {
        title: <span>N/A</span>,
      };
  // if no matched phase, or version_phases is empty, return 'N/A'
  // if enddate and comment both are empty, return 'N/A'
  // if enddate is invalid, and has comment, return comment
  // if enddate is valid, return enddate
  // return 'N/A'
  if (isEmpty(matchedPhase) || isEmpty(matchedPhase.version_phases)) return na;

  const dateString = matchedPhase.version_phases.enddate;
  const comment = matchedPhase.version_phases.comment;

  if (isEmpty(dateString)) {
    if (isEmpty(comment)) return na;
    return stringOnly
      ? comment
      : {
          title: <span title={comment}>{comment}</span>,
          props: { className: "font-italic" },
        };
  }

  try {
    // Try to use own method to parse date
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    const value = month + " " + day + ", " + year;
    const title = formatDistanceToNow(date, { addSuffix: true });

    return stringOnly
      ? value
      : {
          title: <span title={title}>{value}</span>,
        };
  } catch (error) {
    return stringOnly
      ? dateString
      : {
          title: <span title={dateString}>{dateString}</span>,
          props: { className: "font-italic" },
        };
  }
}

// using format
export function stringToTimeStamp(string) {
  let data = {
    date: null,
    string: null,
  };

  if (!isValidDateString(string)) {
    data.string = string;
    return data;
  }

  try {
    const date = new Date(string);
    // the date is based on user's local timezone
    // hardcode to convert to the UTC timezone
    // if the input string in in format of '1970-01-01T'
    // we don't need to convert to UTC timezone
    const reg = new RegExp(/\d{4}-[01]\d-[0-3]\dT/);

    if (!string.match(reg)) {
      date.setTime(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    const value = date.toISOString();
    data.date = value;
  } catch (error) {
    data.string = string;
  }
  return data;
}
